import React from "react";
import { Star, ArrowRight } from "lucide-react";
import { testimonials } from "../mock";

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-16 lg:py-24 bg-gradient-to-b from-transparent to-orange-50/40">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-50 text-[#ee6c4d] text-xs font-semibold tracking-[0.2em] uppercase">
            Loved by families
          </div>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl md:text-5xl text-[#122b45] leading-tight">
            Real stories. <span className="text-[#ee6c4d]">Real progress.</span>
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed text-sm sm:text-base">
            Reviews from Google and moments from our Instagram — straight from the families we serve.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={t.name} className={`bg-white rounded-2xl p-7 border border-orange-100/50 shadow-[0_18px_40px_-25px_rgba(18,43,69,0.18)] hover:-translate-y-1 transition-transform duration-300 reveal reveal-delay-${(i + 1) * 200}`}>
              <div className="flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover" />
                <div>
                  <div className="font-semibold text-[#122b45]">{t.name}</div>
                  <div className="text-xs text-slate-400">{t.when}</div>
                </div>
              </div>
              <div className="flex gap-1 mt-4 text-[#f5a623]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#f5a623]" />
                ))}
              </div>
              <p className="mt-4 text-slate-600 leading-relaxed text-[15px]">“{t.text}”</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <a href="#" className="group inline-flex items-center gap-3 bg-white border border-orange-100 rounded-full pl-2 pr-5 py-2 hover:border-[#ee6c4d] transition">
            <span className="flex items-center gap-1 bg-orange-50 rounded-full px-3 py-1.5">
              <Star className="w-4 h-4 fill-[#f5a623] text-[#f5a623]" />
              <span className="text-sm font-semibold text-[#122b45]">5.0</span>
            </span>
            <span className="text-sm text-[#122b45] font-medium">See all reviews on Google</span>
            <ArrowRight className="w-4 h-4 text-[#ee6c4d] group-hover:translate-x-1 transition" />
          </a>
        </div>
      </div>
    </section>
  );
}
